import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const desktop: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M14-4.25v-6.5a.22.22 0 0 0-.078-.172.22.22 0 0 0-.172-.078H1.25a.24.24 0 0 0-.172.078.2.2 0 0 0-.078.172v6.5c0 .063.023.121.078.172.05.055.11.078.172.078h12.5c.07 0 .129-.023.172-.078.05-.05.078-.11.078-.172m1-6.5v8.5q0 .515-.375.89c-.242.243-.531.36-.875.36H9.5q-.001.281.125.61.122.314.25.546C9.957.32 10 .438 10 .5c0 .133-.055.25-.156.344A.46.46 0 0 1 9.5 1h-4a.5.5 0 0 1-.36-.156A.47.47 0 0 1 5 .5q-.001-.11.125-.344a6 6 0 0 0 .25-.547A1.7 1.7 0 0 0 5.5-1H1.25c-.344 0-.64-.117-.89-.36A1.23 1.23 0 0 1 0-2.25v-8.5c0-.344.117-.633.36-.875Q.734-12 1.25-12h12.5c.344 0 .633.125.875.375.25.242.375.531.375.875m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 12)"
    />
  ),
  svgProps: {
    height: "13",
    width: "15",
  }
};